import { Injectable } from "@angular/core";

Injectable({
  providedIn: 'root'
})

export const Servers = [
  { "value": "DEV", "label": "DEV"}, // This is for development server
  { "value": "QAS", "label": "QAS"}, // This is QAS server
  { "value": "NA", "label": "NA"}, // This is North America server
  { "value": "EUR", "label": "EUR"}, // This is europe server
  { "value": "CH", "label": "CH"}, // This is switzerland server
  { "value": "MENA", "label": "MENA"} // This is middle east and north Africe server
];
